export const ru = {
  hero: {
    title: "Торгуйте <span>Умнее</span> с Phemex + METRADE",
    subtitle: "Профессиональные торговые стратегии теперь доступны всем",
    startTrading: "Зарегистрируйтесь Бесплатно",
    signUpForFree: "Зарегистрируйтесь Бесплатно",
    learnMore: "Узнать Больше о Phemex",
    poweredBy: "При поддержке",
    socialProof: "Присоединяйтесь к более чем 40,000 трейдеров"
  },
  promo: {
    signUp: "Зарегистрируйтесь сегодня и получите",
    months: "3 МЕСЯЦА БЕСПЛАТНО",
    worth: "Стоимостью 3x29$ • Экономия 87$",
    limitedTime: "Предложение ограничено по времени! Скоро истекает"
  },
  whyMetrade: {
    title: "Почему Стоит Выбрать METRADE",
    subtitle: "Идеальный партнер для торговли на Phemex",
    reason1: {
      title: "Проверенные Стратегии",
      description: "Все торговые стратегии имеют доказанные результаты и тщательно проверены"
    },
    reason2: {
      title: "Управление Рисками",
      description: "Расширенные элементы управления рисками, встроенные в каждую премиум-стратегию для защиты вашего капитала"
    },
    reason3: {
      title: "Швейцарское Качество",
      description: "Сделано в Швейцарии с точностью, надежностью и безопасностью"
    },
    reason4: {
      title: "Простая Интеграция",
      description: "Следуйте стратегии в вашей учетной записи Phemex без технических знаний"
    },
    reason5: {
      title: "Полная Прозрачность",
      description: "Получите доступ к данным о производительности в реальном времени и полной истории торговли"
    },
    reason6: {
      title: "Экспертная Поддержка",
      description: "Специализированная команда профессионалов, готовых помочь вам"
    }
  },
  steps: {
    title: "Начните Свой Торговый Путь",
    subtitle: "Начните с трех простых шагов",
    step1: {
      title: "Бесплатная регистрация",
      description: "Создайте свою учетную запись за секунды, используя только свой адрес электронной почты"
    },
    step2: {
      title: "Выберите Стратегию",
      description: "Просмотрите стратегии, разработанные специально для трейдеров Phemex"
    },
    step3: {
      title: "Подключитесь и Начните",
      description: "Выберите стратегию с нашей управляемой настройкой и начните торговать"
    },
    joinText: "Присоединяйтесь к тысячам успешных пользователей METRADE"
  },
  stats: {
    title: "Проверенная Эффективность",
    subtitle: "Наша платформа обеспечивает стабильные результаты для трейдеров по всему миру",
    activeUsers: "Активные пользователи в 100+ странах",
    tradingVolume: "Ежедневно обрабатываемый объем торгов",
    successRate: "Уровень удовлетворенности по результатам опросов",
    support: "Приоритетная поддержка на нескольких языках"
  },
  features: {
    title: "METRADE Marketplace",
    subtitle: "Присоединяйтесь к тысячам успешных пользователей, изменивших свой торговый опыт",
    feature1: {
      title: "Проверенные Стратегии",
      description: "Доступ к проверенным торговым стратегиям с подтвержденным уровнем успеха до 95%"
    },
    feature2: {
      title: "Управление Рисками",
      description: "Предустановленные параметры риска защищают ваш капитал во время волатильности рынка"
    },
    feature3: {
      title: "Простая Интеграция",
      description: "Подключите свою учетную запись Phemex менее чем за 2 минуты с помощью управляемой настройки"
    },
    feature4: {
      title: "На Основе Данных",
      description: "Принимайте обоснованные решения с помощью аналитики производительности в реальном времени"
    }
  },
  strategyShowcase: {
    title: "Топ Стратегии",
    subtitle: "Откройте для себя наши самые успешные торговые стратегии, доступные на Phemex",
    viewAll: "Посмотреть Все Стратегии",
    strategy1: {
      name: "Мастер Моментума",
      description: "Захватывает рыночные тенденции с точными точками входа и выхода",
      roi: "+175% ROI в 2023",
      winRate: "76% Уровень Выигрышей",
      riskLevel: "Средний Риск"
    },
    strategy2: {
      name: "Преимущество Волатильности",
      description: "Процветает на волатильных рынках с адаптивными торговыми параметрами",
      roi: "+205% ROI в 2023",
      winRate: "81% Уровень Выигрышей",
      riskLevel: "Средне-Высокий Риск"
    },
    strategy3: {
      name: "Устойчивый Рост",
      description: "Консервативный подход, ориентированный на стабильную прибыль",
      roi: "+90% ROI в 2023",
      winRate: "89% Уровень Выигрышей",
      riskLevel: "Низкий Риск"
    },
    phemexCompatible: "Оптимизировано для Phemex"
  },
  testimonials: {
    title: "Истории Успеха",
    subtitle: "Узнайте от трейдеров, которые уже получают выгоду от наших стратегий",
    testimonial1: {
      quote: "Я пробовал несколько платформ для копирования сделок, но интеграция METRADE с Phemex на сегодняшний день является самой плавной. Моя прибыль увеличилась на 43% с тех пор, как я начал.",
      author: "Михаил Т.",
      location: "Великобритания",
      strategy: ""
    },
    testimonial2: {
      quote: "Как начинающий трейдер, я постоянно терял деньги. Благодаря стратегиям METRADE на Phemex я, наконец, вижу положительные результаты, не тратя часы на графики.",
      author: "Сара К.",
      location: "Сингапур",
      strategy: ""
    },
    testimonial3: {
      quote: "Прозрачность - это то, что впечатлило меня больше всего. Я могу точно видеть, как работают мои стратегии, а элементы управления рисками спасли мой капитал во время недавних падений рынка.",
      author: "Алекс Д.",
      location: "Германия",
      strategy: ""
    }
  },
  faq: {
    title: "Часто Задаваемые Вопросы",
    subtitle: "Найдите ответы на общие вопросы об интеграции METRADE и Phemex",
    question1: {
      question: "Как работает интеграция Phemex-METRADE?",
      answer: "Наша платформа подключается к вашей учетной записи Phemex через безопасные ключи API с разрешениями только на торговлю. После подключения выбранные вами стратегии будут автоматически выполнять сделки от вашего имени на основе предопределенных параметров."
    },
    question2: {
      question: "Какой минимальный капитал требуется для начала?",
      answer: "Минимум составляет 1800 USDT для бесплатной стратегии. Минимум 2300 USDT для премиум-стратегии с управлением рисками."
    },
    question3: {
      question: "Как я могу контролировать и управлять своим риском?",
      answer: "Каждая стратегия поставляется со встроенными настройками управления рисками, которые вы можете просмотреть перед активацией. Вы можете установить максимальные лимиты просадки, и наша платформа автоматически прекратит торговлю, если эти лимиты будут достигнуты."
    },
    question4: {
      question: "Могу ли я настроить торговые стратегии?",
      answer: "Да, премиум-пользователи могут настраивать определенные параметры стратегий, включая размер позиции, максимальное количество одновременных сделок и уровни толерантности к риску. Наши базовые планы предлагают предварительно настроенные стратегии."
    },
    question5: {
      question: "Что произойдет, если я захочу прекратить использование стратегии?",
      answer: "Вы можете приостановить или отключить стратегию в любое время одним щелчком мыши. Это немедленно остановит любые новые сделки, предоставив вам варианты управления существующими открытыми позициями."
    },
    question6: {
      question: "Есть ли какие-либо скрытые комиссии?",
      answer: "Нет. Мы взимаем прозрачную ежемесячную абонентскую плату в завис��мости от выбранного вами плана. Нет никаких дополнительных комиссий с п��ибыли или скрытых платежей. Вы платите только стандартные торговые комиссии Phemex."
    }
  },
  footer: {
    copyright: "Все права защищены."
  },
  languageSelector: {
    language: "Язык"
  },
  cta: {
    title: "Готовы изменить свою торговлю?",
    subtitle: "Начните с бесплатного 3-месячного периода сегодня",
    buttonText: "Зарегистрируйтесь Бесплатно",
    noCredit: "Кредитная карта не требуется для бесплатного периода"
  }
};
